/**
 * Created by andrey on 18.05.2026
 */

const EditorCommandLog = function () {
    cleverapps.EventEmitter.call(this);

    this.entries = [];
};

EditorCommandLog.prototype = Object.create(cleverapps.EventEmitter.prototype);
EditorCommandLog.prototype.constructor = EditorCommandLog;

EditorCommandLog.prototype.add = function (uid, userId, type, data) {
    const d = new Date();
    const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

    const entry = {
        uid,
        time,
        userId,
        text: EditorCommandLog.formatCommand(type, data),
        undone: false
    };
    this.entries.push(entry);

    this.trigger("addEntry", entry);
};

EditorCommandLog.prototype.markUndone = function (uid) {
    const entry = this.entries.find((e) => e.uid === uid);
    if (entry) {
        entry.undone = true;
        this.trigger("entryUpdated", entry);
    }
};

EditorCommandLog.prototype.markRedone = function (uid) {
    const entry = this.entries.find((e) => e.uid === uid);
    if (entry) {
        entry.undone = false;
        this.trigger("entryUpdated", entry);
    }
};

EditorCommandLog.formatCommand = function (type, data) {
    const unitLabel = data.code !== undefined ? ` ${data.code}_${data.stage}` : "";
    const decoLabel = data.code ? ` ${data.code}` : "";

    switch (type) {
        case "produceUnit": return `place unit${data.unit ? ` ${data.unit.code}_${data.unit.stage}` : ""}`;
        case "deleteUnit": return `rm unit${unitLabel}`;
        case "moveUnit": return `move unit${unitLabel}`;
        case "toggleLock": return `lock unit${unitLabel}`;
        case "shiftMultiple": return `shift ${data.code}_${data.stage}`;
        case "produceDecorator": return `place deco ${data.code}`;
        case "removeDecorator": return `rm deco${decoLabel}`;
        case "moveDecorator": return `move deco${decoLabel}`;
        case "rotateDecorator": return `rotate deco${decoLabel}`;
        case "scaleDecorator": return `scale deco${decoLabel}`;
        case "changeDecoratorCell": return `cell deco${decoLabel}`;
        case "produceMap": return "paint tile";
        case "produceFogTile": return `add fog ${data.code}`;
        case "removeFogTile": return `rm fog ${data.code}`;
        case "moveFogBalloon": return `move balloon ${data.fogId || ""}`;
        case "moveFogHead": return `move head ${data.code}`;
        case "createRegion": return `create region ${data.code}`;
        case "deleteRegion": return `rm region ${data.code}`;
        case "clearRegion": return `clear region ${data.code}`;
        case "restoreRegion": return `restore region ${data.code || ""}`;
        case "renameRegion": return `rename ${data.oldCode}→${data.code}`;
        case "moveRegion": return `move region ${data.code}`;
        case "changeMapSize": return `resize ${data.newSize}`;
        default: return type;
    }
};
